<template>
  <div>
    <b-row>
      <b-col lg="12">
        <div class="text-center p-5 row" v-if="isLoading">
          <semipolar-spinner :animation-duration="2000" :size="80" color="#63c2de" class="offset-6"></semipolar-spinner>
        </div>
        <table-propuestas
          :table-data="items"
          :fields="fields"
          caption=" <h4><i class='far fa-hand-point-up pr-2'></i>Propuestas</h4>"
          v-else
        ></table-propuestas>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { shuffleArray } from "@/shared/utils";
import TablePropuestas from "./TablePropuestas";
import store from "../../store";
import { SemipolarSpinner } from "epic-spinners";
import {
  mdbContainer,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalFooter,
  mdbRow,
  mdbBtn,
  mdbIcon,
  mdbTextarea,
  mdbInput
} from "mdbvue";

export default {
  name: "partners",
  components: {
    TablePropuestas,
    SemipolarSpinner,
    mdbContainer,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbModalFooter,
    mdbRow,
    mdbBtn,
    mdbIcon,
    mdbTextarea,
    mdbInput
  },
  data: () => {
    return {
      items: [],
      itemsArray: [],
      fields: [
        { key: "name", label: "Nombre", sortable: true },
        { key: "description", label: "Descripción", sortable: true },
        { key: "acciones", label: "Acciones" }
      ],
      isLoading: false
    };
  },
  mounted() {
    this.getPropuestas();
  },
  methods: {
    getPropuestas() {
      var propuestas = store.getters.getPropuestas;
      if (propuestas.length == 0) {
        this.isLoading = true;
        //store.dispatch("getStates","madr")
        store.dispatch("getPropuestas").then(() => {
          propuestas = store.getters.getPropuestas;
          shuffleArray([propuestas]);
          this.isLoading = false;
          this.items = propuestas;
          this.itemsArray = propuestas;
        });
      } else {
        shuffleArray([propuestas]);
        this.items = propuestas;
        this.itemsArray = propuestas;
      }
    }
  }
};
</script>
